module.exports = __webpack_public_path__ + "static/media/coreValues-01.8eb162ce.svg";